import { createRouter, createWebHistory } from "vue-router";
import authStore from "@/store/auth";

// 分類對照表
const routeGroups = {
  'xobject-management': 'xObject 元件庫管理',
  'revit-engineering': '工程技術後台',
  'customer-management': '客戶管理',
};

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { title: '登入' },
    component: () => import('../views/loginPage.vue'),
  },
  {
    path: '/',
    name: 'mainLayout',
    redirect: '/dashboard',
    component: () => import('@/views/MainLayout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        meta: { title: '儀表板', hideBreadcrumbs: true },
        component: () => import('@/views/dashboard.vue'),
      },
      {
        path: 'employee-management',
        name: 'employeeManagement',
        meta: { title: '內部員工管理', roles: ['SuperAdmin'] },
        component: () => import('@/views/employeeManagement.vue'),
      },
      {
        path: 'xobject-management/public-components',
        name: 'xObjectPublicComponents',
        meta: { title: '管理公開元件清單', group: 'xobject-management' },
        component: () => import('@/views/xObjectPublicComponents.vue'),
      },
      {
        path: 'xobject-management/public-components/:id/edit',
        name: 'xObjectPublicComponentEdit',
        meta: {
          title: '編輯元件',
          group: 'xobject-management',
          parent: 'xObjectPublicComponents',   // 新增：上一層是清單頁

        },
        component: () => import('@/views/xObjectPublicComponentEdit.vue'),
      },
      {
        path: 'xobject-management/public-attributes',
        name: 'xObjectPublicAttributes',
        meta: { title: '管理公開元件清單屬性', group: 'xobject-management' },
        component: () => import('@/views/xObjectPublicAttributes.vue'),
      },
      {
        path: 'xobject-management/default-components',
        name: 'xObjectDefaultComponents',
        meta: { title: '管理各系統預設元件', group: 'xobject-management' },
        component: () => import('@/views/xObjectDefaultComponents.vue'),
      },
      {
        path: 'xobject-management/review-requests',
        name: 'xObjectReviewRequests',
        meta: { title: '審核元件公開申請', group: 'xobject-management' },
        component: () => import('@/views/xObjectReviewRequests.vue'),
      },
      {
        path: 'xobject-management/review-requests/:no',
        name: 'xObjectReviewRequestDetail',
        meta: {
          title: '審核申請',
          group: 'xobject-management',
          parent: 'xObjectReviewRequests',
        },
        component: () => import('@/views/xObjectReviewRequestDetail.vue'),
      },
      {
        path: 'revit-engineering/log-records',
        name: 'logRecords',
        meta: { title: 'Log紀錄', group: 'revit-engineering' },
        component: () => import('@/views/logRecords.vue'),
      },
      {
        path: 'customer-management/customer-users',
        name: 'userCustomer',
        meta: { title: '客戶使用者總覽', group: 'customer-management' },
        component: () => import('@/views/userCustomer.vue'),
      },
      {
        path: 'customer-management/user-plan-overview',
        name: 'userPlanOverview',
        meta: { title: '客戶方案總覽', group: 'customer-management' },
        component: () => import('@/views/userPlanOverview.vue'),
      },
      {
        path: 'customer-management/order-records',
        name: 'orderRecords',
        meta: { title: '訂單紀錄', group: 'customer-management' },
        component: () => import('@/views/orderRecords.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 路由守衛：未登入不可進入後台頁面，已登入不需再進登入頁
router.beforeEach(async (to) => {
  const isLoggedIn = !!localStorage.getItem('accessToken');

  if (to.name !== 'login' && !isLoggedIn) {
    return { name: 'login' };
  }

  if (to.name === 'login' && isLoggedIn) {
    return { name: 'dashboard' };
  }

  // 未登入且前往登入頁，不需取得使用者資訊
  if (!isLoggedIn) return;

  // 重新整理後 user 會清空，有 token 但沒有使用者資訊時重新取得
  const auth = authStore();
  if (!auth.user.role) {
    try {
      await auth.verify();
    } catch (error) {
      // 取不到使用者資訊就清除 token，避免登入頁與儀表板之間來回導向
      auth.clearTokens();
      return { name: 'login' };
    }
  }

  // 角色權限：meta.roles 有設定且不包含目前角色時，導回儀表板
  if (to.meta.roles && !to.meta.roles.includes(auth.user.role)) {
    return { name: 'dashboard' };
  }
});

router.afterEach((to) => {
  document.title = to.meta.title
    ? `${to.meta.title} | 萃思科技 MindLogic`
    : "萃思科技 MindLogic";
});

export default router;
export { routeGroups };